<script>
  import AppHeader from './components/main/Header.vue'
  import AppSidebar from './components/main/Sidebar.vue'
  import {mapGetters, mapActions} from 'vuex'
  import bus from '@utils/bus'

  export default {
    name: 'App',
    components: {AppHeader, AppSidebar},
    computed: {
      ...mapGetters(['isLogged', 'isLoading', 'currentUser'])
    },
    methods: {
      ...mapActions(['showLoader', 'hideLoader'])
    },
    mounted () {
      document.cookie = 'token=testandotoken;path=/;domain=urcamp.edu.br'
      /**
       * Listener que ficam escutando os eventos para esconder e mostrar o loader na aplicação
       */
      bus.$on('show-loader', () => this.showLoader())
      bus.$on('hide-loader', () => this.hideLoader())
    }
  }
</script>

<template>
    <div id="app">
        <AppHeader v-if="isLogged"></AppHeader>
        <AppSidebar v-if="isLogged"></AppSidebar>
        <div class="app-content" v-bind:class="{'-not-logged': !isLogged}">
            <div v-if="!isLogged">
                <router-link :to="{ name: 'auth' }"
                             class="el-button el-button--default login-btn">
                    <i class="fa fa-user"></i>
                    <span>Fazer Login</span>
                </router-link>
            </div>
            <div :class="{ 'container': isLogged }"
                 v-loading.fullscreen.lock="isLoading"
                 element-loading-text="Carregando Dados...">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<style src="assets/sass/app.scss" lang="scss"></style>
<style src="assets/sass/responsive.scss" lang="scss"></style>
